import React from "react";
import _ from "lodash";
import ContentInputsTypesEnum from "../../../../enums/ContentInputsTypesEnum";
import generateContentDataObject from "../../../../helpers/editor/generateContentDataObject";
import DebouncedTextarea from "../../../DebouncedTextarea";
import { GraphicsOptions } from "../../component_graphics/data/componentGraphicsData";
import { useCurrentInputData } from "../useCurrentInputData";

interface Props {
  saveContentInStore: any;
  contentType: ContentInputsTypesEnum;
  currentInputData: any;
  keyProp: number;
  toggleNewEditionsDetected: (value: boolean) => void;
  item: any;
}

const GalleryHTMLInput = (props: Props): JSX.Element => {
  const {
    saveContentInStore,
    contentType,
    currentInputData,
    keyProp,
    toggleNewEditionsDetected,
    item,
  } = props;
  const currentInputDataRef = useCurrentInputData(currentInputData);

  const generator = new generateContentDataObject();

  const handleOnChange = (value: string) => {
    saveContentInStore(
      generator.changeGalleryCodeSnippet(
        { [contentType]: currentInputDataRef.current },
        value,
        keyProp,
        0
      )
    );
    toggleNewEditionsDetected(true);
  };

  return (
    <div className="content-input__input">
      <DebouncedTextarea
        className="content-input__input content-input__input--monospace"
        placeholder={"Enter any HTML code. Examples: <iframe> <script> etc."}
        autosize={{ minRows: 2, maxRows: 20 }}
        onChange={handleOnChange}
        defaultValue={_.get(item, [
          "contentGraphic",
          0,
          GraphicsOptions.HTML,
          "codeSnippet",
        ])}
        id={contentType}
      />
    </div>
  );
};

export default GalleryHTMLInput;
